import { getVersion } from '../../../releases';
import { SalesType } from '../common/types';
import { Actions } from '../helpers/types';

type GAPayloadBase = {
  influencer_id: number;
  //   influencer_name: string;
};

type GAPayloadWorkout = GAPayloadBase & {
  workout_name: string;
};

type GAPayloadCollection = GAPayloadBase & {
  collection_id: number;
  collection_type: SalesType | 'category';
};

export type GAEvent = Actions<{
  'Registration Completed': GAPayloadBase;
  'Profile Set Up Completed': GAPayloadBase;
  'Payments Set Up Started': GAPayloadBase;
  'Exercise Video Uploaded': GAPayloadBase; // TODO:
  'Workout Created': GAPayloadWorkout;
  'Workout Published': GAPayloadWorkout;
  'Collection Created': GAPayloadCollection;
  'Collection Updated': GAPayloadCollection;
  'Collection Published': GAPayloadCollection;
  'Creator Go Live': GAPayloadBase;
}>;
let _eventPrefix: string | null = null;
export const emitGAEvent = async (event: GAEvent) => {
  const appVersion = getVersion();
  if (_eventPrefix === null)
    _eventPrefix = import.meta.env.VITE_ENV !== 'production' ? 'test.' : '';
  console.log('GA4 event: ', appVersion, _eventPrefix, event);

  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dataLayer = (window as any).dataLayer || [];
    dataLayer.push({
      event: _eventPrefix + event.type,
      appVersion,
      ...(event.payload || {}),
    });
  } catch (e) {
    console.log('GA4', e);
  }
};
